import { Typography,Box } from "@mui/material";
import { useMemo } from "react";

const RandomEquationBackground = () => {
    const equations = [
      "E = mc²",
      "F = ma",
      "a² + b² = c²",
      "e^(iπ) + 1 = 0",
      "∇·E = ρ/ε₀",
      "Δx Δp ≥ ħ/2",
      "V = IR",
      "PV = nRT",
      "∑ₙ₌₁∞ 1/n² = π²/6",
    ];
  
    const rows = 6;
    const columns = 15;
    const verticalSpacing = 100 / (rows - 1);
    const horizontalSpacing = 100 / (columns - 1);
    const diagonalOffset = horizontalSpacing / 2;
  
    const equationElements = useMemo(() => {
      const elements = [];
      for (let row = 0; row < rows; row++) {
        for (let col = 0; col < columns; col++) {
          const eq = equations[(row * columns + col) % equations.length];
          const top = row * verticalSpacing;
          const left = col * horizontalSpacing + row * diagonalOffset;
          const rotate = -45;
          const fontSize = 16;
          elements.push(
            <Typography
              key={`${row}-${col}`}
              sx={{
                position: 'absolute',
                top: `${top}%`,
                left: `${left}%`,
                transform: `rotate(${rotate}deg)`,
                fontSize: `${fontSize}px`,
                color: 'rgba(255,255,255,0.3)',
                userSelect: 'none',
                whiteSpace: 'nowrap',
              }}
            >
              {eq}
            </Typography>
          );
        }
      }
      return elements;
    }, [equations, rows, columns, verticalSpacing, horizontalSpacing, diagonalOffset]);
  
    return (
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          pointerEvents: 'none',
          zIndex: -1,
        }}
      >
        {equationElements}
      </Box>
    );
  };

  export default RandomEquationBackground;